<template>
 <div class="card-panel hoverable">
      <router-link
      to="/"
        class="waves-effect waves-light btn-small left"
    >Back</router-link>
    <br>
     <h5 style="margin-bottom: 20px"></h5>
 <!-- <router-link to="/tariff/nerc1"> -->
    <!-- <div class="row">
           <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'nerc1' }}">
                <img src="ui/img/power/nerc.png" width="120px" class="responsive-img" />
                <p style="font-weight: 700">NERC 1</p>
                </router-link>
            </div>
            <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'nerc2' }}">
                    <img src="ui/img/power/nerc.png" width="120px" class="responsive-img" />
                    <p style="font-weight: 700">NERC 2</p>
                </router-link>
            </div>
          
      </div> -->

     <!-- <div class="row">
           <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'AEDC' }}">
                <img src="ui/img/power/Aedc.png" width="120px" class="responsive-img" />
                <p>AEDC</p>
                </router-link>
            </div>
            <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'EEDC' }}">
                    <img src="ui/img/power/EEDC.jpg" width="120px" class="responsive-img" />
                    <p>EEDC</p>
                </router-link>
            </div>
            <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'ibadan' }}">
                    <img src="ui/img/power/ibedc3.jpg" width="120px" class="responsive-img" />
                    <p>IBEDC</p>
                </router-link>
            </div>
      </div> -->
      <div class="row">
           <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'AEDC' }}">
                <img src="ui/img/power/Aedc.png" width="120px" class="responsive-img" />
                <p>AEDC</p>
                </router-link>
            </div>
            <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'EEDC' }}">
                    <img src="ui/img/power/EEDC.jpg" width="120px" class="responsive-img" />
                    <p>EEDC</p>
                </router-link>
            </div>
            <div class="col s4 m4">
                <router-link :to="{ name: 'cost', params: { image: 'ibadan' }}">
                    <img src="ui/img/power/ibedc3.jpg" width="120px" class="responsive-img" />
                    <p>IBEDC</p>
                </router-link>
            </div>
      </div>
      <div class="row">
        <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'ikeja' }}">
                <img src="ui/img/power/ikeja.png" width="120px" class="responsive-img" />
                <p>Ikeja</p>
            </router-link>
        </div>
        <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'PHED' }}">
                <img src="ui/img/power/phed.png" width="120px" class="responsive-img" />
                <p>PHED</p>
            </router-link>
        </div>
        <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'BEDC' }}">
                <img src="ui/img/power/bedc.jpeg" width="120px" class="responsive-img" />
                <p>BEDC</p>
            </router-link>
        </div>
      </div>
        <div class="row">
        <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'Kaduna' }}">
                <img src="ui/img/power/kaduna.png" width="120px" class="responsive-img" />
                <p>Kaduna Electric</p>
            </router-link>
        </div>
        <!-- <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'YEDC' }}">
                <img src="ui/img/power/yola.png" width="120px" class="responsive-img" />
                <p>YEDC</p>
            </router-link>
        </div> -->
         <div class="col s4 m4">
            <router-link :to="{ name: 'cost', params: { image: 'Eko' }}">
                <img src="ui/img/power/eko.jpg" width="120px" class="responsive-img" />
                <p>Eko</p>
            </router-link>
        </div>
      </div>      
     
 </div>
</template>

<script>
export default {

}
</script>

<style>

</style>